import { useNavigate, useParams } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { adminRoute, superAdminRoute } from "utils/constants";
import { getDataFromLocalStorage } from "utils/helpers";
import InstitutionalCertificates from "./InstitutionalCertificates";
import EventCertificates from "./EventCertificates";
// import EventCertificates from "./EventCertificatesV2";
import MembershipCertificates from "./MembershipCertificates";

const CertificateManagement = () => {
  const params = useParams();
  const { user_type: userType } = getDataFromLocalStorage();
  const navigate = useNavigate();

  const handleRedirect = (type) => {
    navigate(
      `${
        userType === "1"
          ? superAdminRoute.certificateManagement
          : adminRoute.certificateManagement
      }/${type}`
    );

    // navigate(`${adminRoute.certificateManagement}/${type}`);
  };

  return (
    <div>
      {["0", "1"].includes(userType) && (
        <Tabs
          defaultActiveKey={params?.type}
          id="uncontrolled-tab-example"
          className="mb-3 gap-4"
        >
          <Tab
            eventKey="event-certificates"
            title="Event Certificates"
            onEnter={() => {
              handleRedirect("event-certificates");
            }}
          />

          <Tab
            eventKey="membership-certificates"
            title="Membership Certificates"
            onEnter={() => {
              handleRedirect("membership-certificates");
            }}
          />

          <Tab
            eventKey="institutional-certificates"
            title="Institutional Certificates"
            onEnter={() => {
              handleRedirect("institutional-certificates");
            }}
          />
        </Tabs>
      )}
      {params?.type === "event-certificates" && <EventCertificates />}
      {params?.type === "membership-certificates" && <MembershipCertificates />}
      {params?.type === "institutional-certificates" && (
        <InstitutionalCertificates />
      )}
    </div>
  );
};
export default CertificateManagement;

